import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    types: [],
    fetching: true
  },
  mutations: {
    setTypes (state, types) {
      state.types = types
    }
  },
  actions: {
    fetch ({ state, commit }) {
      state.fetching = true

      apiService.getFormsTypesAccess()
        .then(response => {
          commit('setTypes', response.data.types)

          state.fetching = false
        })
        .catch(() => {
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список доступных типов доступов на получение.'
          })
        })
    }
  }
}
